var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomLinkAccount = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    id: "mpbq9h4jva"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#mpbq9h4jva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.895 23.863a1.094 1.094 0 0 1 0 2.187h-9.957a8.503 8.503 0 0 0 1.37-2.187zm-1.368-13.775a.547.547 0 1 1 0 1.093h-.273v9.84h.273a1.094 1.094 0 1 1 0 2.187H18.56A8.49 8.49 0 0 0 19 20.5a8.46 8.46 0 0 0-1.406-4.684l-.001-4.635H14.31V12.9a8.439 8.439 0 0 0-2.189-.746v-.973H8.84v.981a8.44 8.44 0 0 0-2.189.758v-1.74h-.273a.547.547 0 1 1 0-1.092zm-2.462 1.093h-3.283v9.839h3.283v-9.84zm-7.56-9.085c.285-.128.612-.128.897 0L27.26 6.977a1.094 1.094 0 0 1-.356 2.128H5.01a1.094 1.094 0 0 1-.449-2.09z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm-1.776 6.434a.502.502 0 0 0-.71 0l-1.422 1.422a2.496 2.496 0 0 0-.735 1.776c0 .67.261 1.302.736 1.776.49.49 1.133.735 1.776.735.579 0 1.158-.199 1.624-.595l.152-.14 1.42-1.421a.503.503 0 0 0-.71-.71l-1.42 1.42a1.508 1.508 0 0 1-2.233-2.02l.101-.111 1.42-1.421a.503.503 0 0 0 0-.71zm3.552-.71a.502.502 0 0 0-.71 0l-2.842 2.842a.503.503 0 0 0 .71.71l2.842-2.842a.503.503 0 0 0 0-.71zm2.131-2.132a2.514 2.514 0 0 0-3.552 0l-1.42 1.421a.503.503 0 0 0 .71.71l1.42-1.42a1.508 1.508 0 0 1 2.233 2.02l-.101.111-1.421 1.421a.503.503 0 0 0 .71.71l1.422-1.42a2.496 2.496 0 0 0 .735-1.777c0-.67-.261-1.302-.736-1.776z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomLinkAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-link-account.12757c0d700aa5d376d0980e1764683a.svg";